import React, { useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import SettingsModal from './SettingsModal';

const Header: React.FC = () => {
  const { t } = useLanguage();
  const [showSettings, setShowSettings] = useState(false);
  
  return (
    <>
      <header className="px-3 sm:px-4 md:px-6 lg:px-8 py-3 sm:py-4 border-b border-white/[0.05] bg-black/10 backdrop-blur-sm relative z-[10000]">
        <div className="mx-auto max-w-7xl">
          <div className="flex items-center justify-between gap-3">
            <div className="flex items-center space-x-2 sm:space-x-3 flex-1 min-w-0">
              <div className="flex h-10 w-10 sm:h-11 sm:w-11 items-center justify-center rounded-xl sm:rounded-2xl bg-gradient-to-br from-blue-500 to-blue-600 shadow-lg flex-shrink-0">
                <span className="text-lg sm:text-xl">🌤️</span>
              </div>
              <div className="min-w-0 flex-1">
                <h1 className="text-base sm:text-lg lg:text-xl xl:text-2xl font-bold tracking-tight text-white truncate">
                  {t.appTitle}
                </h1>
                <p className="text-xs text-slate-400 hidden sm:block truncate">
                  {t.serviceFrom}
                </p>
              </div>
            </div>
            
            <div className="flex items-center space-x-2 flex-shrink-0">
              <button
                onClick={() => setShowSettings(true)}
                className="header-btn group"
                aria-label={t.settings}
              >
                <span className="emoji text-cyan-400 group-hover:text-cyan-300 transition-colors">⚙️</span>
                <span className="hidden sm:inline">{t.settings}</span>
              </button>
              <a
                href="https://skitfiske.app"
                className="header-btn group"
              >
                <span className="emoji text-blue-400 group-hover:text-blue-300 transition-colors">🎣</span>
                <span className="hidden sm:inline">Skitfiske.app</span>
              </a>
              <a
                href="mailto:hej@skitfiske.app"
                className="header-btn group"
              >
                <span className="emoji text-blue-400 group-hover:text-blue-300 transition-colors">✉️</span>
                <span className="hidden sm:inline">{t.contactUs}</span>
              </a>
            </div>
          </div>
        </div>
      </header>

      <SettingsModal isOpen={showSettings} onClose={() => setShowSettings(false)} />
    </>
  );
};

export default Header;
